import { verificarQtdMaximaDependentesPorPlano } from './helpers/funcoesAuxiliaresRegrasComum';

export class BuilderRegrasComuns {
    constructor(valoresForm, arrayMsgErro, qtdDependentes, plano) {
        this.valoresForm = valoresForm;
        this.arrayRegrasComum = arrayMsgErro;
        this.qtdDependentes = qtdDependentes;
        this.plano = plano;
    }

    permitirSemAdicionalMenor18anos() {
        const planosNaoIncluslos = ['ZP', 'ZP4', 'ZPA', 'ZPET', 'ZT', 'ZISAF', 'ZCC', 'ZB', 'ZBC'];

        if (!planosNaoIncluslos.includes(this.plano) &&
            this.valoresForm.Idade < 18 &&
            this.valoresForm.Categoria === 'ZELO' &&
            this.arrayRegrasComum?.length === 1 &&
            !verificarQtdMaximaDependentesPorPlano(this.plano, this.qtdDependentes)) {
            this.arrayRegrasComum = [];
        }

        return this;
    }

    naoPermiteParentescoPet() {
        const categoriasNaoPermitidasPet = ['ZPEAD', 'ZPET', 'ZPETA', 'ZPE26'];

        if (!categoriasNaoPermitidasPet.includes(this.valoresForm.Categoria.trim()) &&
            this.valoresForm.Parentesco.trim() === 'PET') {
            this.arrayRegrasComum = ['Somente é permitido dependentes PET se o adicional for específico para o PET'];
        }

        return this;
    }
}
